export var createLogicWrapper = function createLogicWrapper(WrapperClass, getChildrenTypes) {
  // TODO: Implement validate wrapper rendered children to match static children types fetcher
  WrapperClass.getChildrenTypes = getChildrenTypes;
  return WrapperClass;
};